import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Skeleton } from '../../components/ui/skeleton';
import { User, Users } from 'lucide-react';
import { formatEmployeeName } from './helpers';

export const EmployeeGrid = ({ employees, loading, onSelect }) => {
  // Filter out unavailable employees and those without a PIN
  const availableEmployees = employees.filter(emp => !emp.is_unavailable && emp.has_pin);

  if (loading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-3">
        {[1, 2, 3, 4].map(i => <Skeleton key={`skel-${i}`} className="h-24 sm:h-32 bg-white/10" />)}
      </div>
    );
  }

  if (availableEmployees.length === 0) {
    return (
      <Card className="bg-white/10 border-white/20">
        <CardContent className="p-6 sm:p-8 text-center">
          <Users className="h-10 w-10 sm:h-12 sm:w-12 mx-auto mb-4 opacity-50" />
          <p className="text-sm sm:text-base">Keine verfuegbaren Mitarbeiter an diesem Standort</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-3">
      {availableEmployees.map((employee) => (
        <button
          key={employee.id}
          onClick={() => onSelect(employee)}
          className="backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 text-center transition-all focus:outline-none focus:ring-2 focus:ring-primary active:scale-95 bg-white/10 hover:bg-white/20 hover:scale-105"
          data-testid={`employee-select-${employee.id}`}
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mx-auto mb-1 sm:mb-2 bg-primary/20">
            <User className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
          </div>
          <p className="font-medium truncate text-sm sm:text-base text-white">
            {formatEmployeeName(employee)}
          </p>
        </button>
      ))}
    </div>
  );
};
